import React from 'react'
import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export default () => {}

// white-space: pre-line; respects "\n" in text
const cssBase = css`
  color: ${colors.gray100};
  white-space: pre-line;
`

const cssWrap = css`
  overflow-wrap: break-word;
`

const cssBold = css`
  font-weight: bold;
`

export function DmcText({ id, text, wrap = true, bold = false }) {
  const cssClasses = [cssBase]
  if (wrap) {
    cssClasses.push(cssWrap)
  }
  if (bold) {
    cssClasses.push(cssBold)
  }

  return (
    <div data-testid={id} css={cssClasses}>
      {text}
    </div>
  )
}
